import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';
import { Dashboard, Terminals, Create, Update, Info } from './Children';

export const TurnstilesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'turnstilesGroup',
      path: 'turnstiles',
      scopes: getPermissionsForModule('Torniquet'),
      children: [
        {
          scopes: [Scopes.Torniquet.show],
          id: 'turnstilesGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          scopes: [Scopes.Torniquet.show],
          id: 'turnstilesGroup.terminals',
          path: '',
          element: <Terminals />,
        },
        {
          scopes: [Scopes.Torniquet.store],
          id: 'turnstilesGroup.create',
          path: 'create',
          element: <Create />,
        },
        {
          scopes: [Scopes.Torniquet.update],
          id: 'turnstilesGroup.update',
          path: 'update',
          element: <Update />,
        },
        {
          scopes: [Scopes.Torniquet.show],
          id: 'turnstilesGroup.info',
          path: 'info',
          element: <Info />,
        },
      ],
    },
  ],
};
